import axios from "axios";
import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  quote: Yup.string().required("This field is required!"),
  submission_number: Yup.string()
    .required("This field is required!")
    .test("checkSubmissionNumber", "Submission number does not exist", async (value) => {
      if (!value) return false;
      try {
        const response = await axios.get("/api/quote/admin");
        const submissionNumbers = response.data.data.data.submission_number;
        return submissionNumbers.includes(value);
      } catch (error) {
        console.error("Failed to validate submission number", error);
        return false;
      }
    }),
  agency: Yup.string().when("quote", {
    is: (val) => val === "Progressive" || val === "Nirvana",
    then: Yup.string().required("This field is required!"),
  }),
  company: Yup.string().when("quote", {
    is: (val) => val === "Progressive" || val === "Nirvana",
    then: Yup.string().required("This field is required!"),
  }),
  policy_number: Yup.string().when("quote", {
    is: (val) => val === "Progressive" || val === "Nirvana",
    then: Yup.string().required("This field is required!"),
  }),
  contactName: Yup.string().required("Contact name is required!"),
  contactEmail: Yup.string().email("Invalid email format").required("Contact email is required!"),
  contactPhone: Yup.string().required("Contact phone is required!"),
});
